import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5e1ecf77"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"info-main\" data-v-5e1ecf77><p class=\"info-title\" data-v-5e1ecf77>使用目的</p><div class=\"info-desc\" data-v-5e1ecf77>区分不同设备</div></div><div class=\"info-main\" data-v-5e1ecf77><p class=\"info-title\" data-v-5e1ecf77>使用场景</p><div class=\"info-desc\" data-v-5e1ecf77>用户使用APP时</div></div><div class=\"info-main\" data-v-5e1ecf77><p class=\"info-title\" data-v-5e1ecf77>收集主体</p><div class=\"info-desc\" data-v-5e1ecf77>本APP</div></div>", 3);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "IMEI"
  }, null, 8, ["onBack"]), _hoisted_2])]);
}